import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  StockAdministrationDto,
  StockAdministrationSearchRequest,
  UpsertStockAdministrationDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/stock-administration`;

export const searchStockAdministration = (
    searchRequest: Partial<StockAdministrationSearchRequest>,
    source: CancelTokenSource): Promise<Array<StockAdministrationDto>> => {

  return axios
      .post(`${apiUri}/search`, searchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findStockAdministrationById = (
    id: number, source: CancelTokenSource)
    : Promise<UpsertStockAdministrationDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const addStockAdministration = (
    upsertDto: Partial<UpsertStockAdministrationDto>,
    source: CancelTokenSource)
    : Promise<StockAdministrationDto> => {

  return axios
      .post(apiUri, upsertDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editStockAdministration = (
    id: number,
    upsertDto: Partial<UpsertStockAdministrationDto>,
    source: CancelTokenSource)
    : Promise<StockAdministrationDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertDto, {cancelToken: source.token})
      .then(response => response.data);
};
